import { render } from "./cekloksarana.vue?vue&type=template&id=24985072"
import script from "./cekloksarana.vue?vue&type=script&lang=js"
export * from "./cekloksarana.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__